
import React, { useState } from 'react';
import { EmailShareButton, EmailIcon, FacebookShareButton, FacebookIcon, LineShareButton, LineIcon } from "react-share";
import { ShareDiv } from './styled/sharelinkstyled';
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import './css/sharelink.css'

function ShareLink() {
    // ShareLink開關設定
    const [share, setShare] = useState(false);

    // ShareLink開關function
    function shareMenu() {
        setShare(!share);
    }

    return (
        <>
            <ShareDiv share={share} onClick={shareMenu}>
                {/* 這是ShareLink開關箭頭 */}
                <div className='arrowPosition'>
                    {share ? <FaCaretRight /> : <FaCaretLeft />}
                </div>
                {/* 這是ShareLink分享連結 */}
                <div className='sharePosition'>
                    <FacebookShareButton url={`https://reactmaskmap.firebaseapp.com/`}>
                        <FacebookIcon size={50} round={false} />
                    </FacebookShareButton>
                    <LineShareButton url={`https://reactmaskmap.firebaseapp.com/`}>
                        <LineIcon size={50} round={false} />
                    </LineShareButton>
                    <EmailShareButton
                        url={`https://reactmaskmap.firebaseapp.com/`}
                        subject={`【來使用找口罩地圖吧！】`}
                    >
                        <EmailIcon size={50} round={false} />
                    </EmailShareButton>
                </div>

            </ShareDiv>
        </>
    )
}

export default ShareLink;